/**
 * Version checker to ensure users always have the latest version
 * This prevents cached old UI/UX from being served
 */

const APP_VERSION = '1.1.14'; // Should match package.json version
const VERSION_KEY = 'itpcrm_app_version';

export const checkVersion = () => {
  try {
    const storedVersion = localStorage.getItem(VERSION_KEY);

    if (storedVersion !== APP_VERSION) {
      console.log(`Version mismatch detected. Stored: ${storedVersion}, Current: ${APP_VERSION}`);

      // Clear all caches
      if ('caches' in window) {
        caches.keys().then(names => {
          names.forEach(name => {
            caches.delete(name);
          });
        });
      }

      // Update stored version
      localStorage.setItem(VERSION_KEY, APP_VERSION);

      // Force a hard reload to clear all cached resources
      window.location.reload(true);
    }
  } catch (error) {
    console.error('Error checking app version:', error);
  }
};

export const initVersionCheck = () => {
  // Check version on app load
  checkVersion();

  // Set up periodic version checking (every 30 minutes)
  setInterval(() => {
    fetch('/meta.json?t=' + Date.now())
      .then(res => res.json())
      .then(data => {
        if (data.version && data.version !== APP_VERSION) {
          console.log('New version detected, reloading...');
          localStorage.setItem(VERSION_KEY, data.version);
          window.location.reload(true);
        }
      })
      .catch(err => console.error('Failed to check version:', err));
  }, 30 * 60 * 1000); // 30 minutes
};